import { render } from "./InfoUpload.vue?vue&type=template&id=e621e5ce"
import script from "./InfoUpload.vue?vue&type=script&lang=js"
export * from "./InfoUpload.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__